import api from './api';

export const blogService = {
    /**
     * Get all blog posts with featured post
     * @returns {Promise} Response with { featuredPost, posts }
     */
    getAll: async (params = {}) => {
        return api.get('/posts', { params });
    },

    /**
     * Get single blog post by slug
     * @param {string} slug - Post slug
     * @returns {Promise} Response with { post, relatedPosts }
     */
    getBySlug: async (slug) => {
        return api.get(`/posts/${slug}`);
    },
};
